import type { PipelineCardDetail } from '@/pages/pipelines/common/types';

type DetailBadge = PipelineCardDetail['badges'][number];
type DetailSection = PipelineCardDetail['sections'][number];
type DetailRow = PipelineCardDetail['sections'][number]['rows'][number];
type DetailTimelineItem = PipelineCardDetail['timeline'][number];

export const getPipelineDetailBadges = (
  _detail: PipelineCardDetail,
  badges: DetailBadge[],
): DetailBadge[] => badges;

export const getPipelineDetailRowValue = (row: DetailRow) => row.value;

export const getPipelineDetailRowLabel = (_detail: PipelineCardDetail, row: DetailRow) => row.label;

export const getPipelineDetailBlockLabel = (detail: PipelineCardDetail, section: DetailSection) => {
  const [row] = section.rows;
  if (row && section.title === row.label) return getPipelineDetailRowLabel(detail, row);

  return section.title;
};

export const getPipelineIndicatorRows = (detail: PipelineCardDetail): DetailRow[] =>
  detail.indicators.map((indicator) => ({
    key: indicator.key,
    label: indicator.label,
    value: indicator.active ? 'Yes' : 'No',
    tone: indicator.active ? 'green' : undefined,
  }));

export const getPipelineDetailTimeline = (detail: PipelineCardDetail): DetailTimelineItem[] =>
  detail.timeline;
